import axios from '@/axios';

// URL and endpoint constants
const INDEX_URL = '/science_in_schools';

export default {
  index(succ) {
    axios.get(INDEX_URL)
      .then((response) => { succ(response); });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/scienceInSchool.js